// ----------------------------------------------------------------------
// <copyright file="Izenda.Tree.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * Tree component
 */
!(function() {


  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var LazyLoadingTreeView = require('share/components/controls/LazyLoadingTreeView/Izenda.LazyLoadingTreeView');
  var Input = require('share/components/controls/Izenda.Input');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var actions = require('./Izenda.LazyLoadingTreeActions');
  var PropTypes = React.PropTypes;
  const { invoke } = require('lodash/fp');

  var LazyLoadingTree = React.createClass({
    propTypes: {
      data: PropTypes.object.isRequired,
      getData: PropTypes.func.isRequired,
      isLastPage: PropTypes.bool.isRequired
    },

    /**
     * Render node
     * @param {Object} node
     * @param {String} toggleIcon
     * @param {Boolean} toggle
     * @param {Boolean} isCollapsed
     */
    renderNode: function(node, toggleIcon, toggle, isCollapsed, parent) {
      var source = node.source,
        onChangeFunc = node.onChange.bind(null, source, parent),
        isLeafNode = node.isLeafNode,
        showTotal = node.showTotal,
        disabled = node.disabled,
        props = this.props,
        name = source.name;

      return (
        <div>
          <Input
            type="checkbox"
            indeterminate={source.indeterminate}
            checked={disabled ? false : source.checked}
            onChange={onChangeFunc}
            disabled={disabled}
          />
          <TextHighLight
            highlight={props.filterText}
            onClick={toggle}
            text={name}
            className="selectable u_inline u_paddingLeft"
            tooltip={name}
          />
          {showTotal && <span className="selectable u_inline u_paddingLeft">({source.numOfChilds})</span>}
          {!isLeafNode && toggleIcon}
        </div>
      );
    },

    render: function() {
      var props = this.props;
      var getChildNodes = invoke('getChildNodes');

      return (
        <LazyLoadingTreeView
          className="u_paddingRight"
          nodes={props.data}
          isLastPage={props.isLastPage}
          renderNode={this.renderNode}
          getKey={props.getKey}
          getChildNodes={getChildNodes}
          collapsed={false}
          getData={props.getData}
        />
      );
    }
  });

  module.exports = connect(actions)(LazyLoadingTree);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/Tree/Izenda.LazyLoadingTree.jsx